module.exports = __webpack_public_path__ + "static/media/15_andinvainthedreamer.b38f848a.jpg";